import { AutenticacionService } from './../autenticacion.service';
import { Injectable } from '@angular/core';
declare var $;

@Injectable()
export class HelpersService {

  constructor(private authService: AutenticacionService) { }

  notification(title, description, type) {
    $.NotificationApp.send(title, description, 'bottom-right', 'rgba(0,0,0,0.2)', type);
  }

  substract_days(fecha, days) {
    let d = new Date(fecha);
    d.setDate(d.getDate() - days);
    const curr_date = d.getDate();
    var strDay = '';
    if(curr_date<10){
       strDay = '0'+curr_date;
    }else{
      strDay = ''+curr_date;
    }
    const curr_month = d.getMonth() + 1; 
    var strMonth = '';
    if(curr_month<10){
       strMonth = '0'+curr_month;
    }else{
      strMonth = ''+curr_month;
    }
    const curr_year = d.getFullYear();
    console.log(curr_year + '-' + strMonth + '-' + strDay);
    return curr_year + '-' + strMonth + '-' + strDay;
  }

  httpGlobalError(error, notification = true) {
    if (error.status == 403) {
      // usuario sin sessión activa
      this.authService.killUser();
    } else if (error.status == 500 && notification) {
      // error en el backend
      this.notificationErrorDefault();
    } else if (error.status == 400) {
      //Bad request, se imprime respuesta del backend
      const body = JSON.parse(error["_body"]);
      const errors = body["content"];
      console.log("httpGlobalError errors: ",errors);
      let errorsText = "<ul>"
      for (var key in errors){
        errorsText = errorsText += "<li>" + errors[key] + ": " + key + "</li>"
      }
      errorsText = errorsText += "</ul>"
      this.notification("Validar información",errorsText,"error");
    } else if (error.status == 0) {
      this.notificationErrorDefault();
    }
  }

  notificationErrorDefault() {
    this.notification('ERROR', 'No se completó la acción. Por favor, inténtelo más tarde', 'error');
  }

  notificationErrorArray(arr) {
    console.log(arr);
    let errorsText = "<ul>";
    for (var key in arr){
      errorsText = errorsText += "<li>" + arr[key] + ": " + key + "</li>"
    }
    errorsText = errorsText += "</ul>"
    this.notification('ERROR', errorsText, 'error');
  }

  getMonthYearByDate(date, previous = false){
    var cadena = date,separador = "-",arregloDeSubCadenas = cadena.split(separador);
          let año = arregloDeSubCadenas[0];
          let mes = arregloDeSubCadenas[1];
          let dia = arregloDeSubCadenas[2];
          let auxMes = parseInt(mes);
          año = parseInt(año);
          if (previous) {
            if(mes == '01'){
              auxMes = 12;
              año = año - 1;
            }else{
              auxMes = auxMes - 1;
            }
          }
    var cadenaMeses = "Meses,Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",separador = ",",arregloMeses = cadenaMeses.split(separador);
    let nuevoMes = arregloMeses[auxMes];
    //let fechaLiquidacion = año + "-" + auxMes.toString() + "-" + dia; // otro format que no usaremos por ahorita
    return nuevoMes + ' ' + año;
  }

  castToNumber(stringNumber){
    return Number(stringNumber);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/tools/helpers.service.ts